import React from 'react';
import styles from './styles.module.css';

interface ButtonLinkProps
  extends React.AnchorHTMLAttributes<HTMLAnchorElement> {
  as?: 'a';
  color?: string;
  target?: '_blank' | '_self';
  title?: string;
  icon: JSX.Element;
  linkUrl?: string;
  bgColor?: string;
  fontSize?: string;
}

const getCSSCustomProperty = (
  propertyName: string,
  fallback: string = ''
): string => {
  if (typeof window === 'undefined' || typeof document === 'undefined') {
    const defaultValues: Record<string, string> = {
      '--color-surface': '#ffffff',
      '--color-background-dark': '#0049a9',
    };
    return defaultValues[propertyName] || fallback;
  }

  const rootStyles = getComputedStyle(document.documentElement);
  return rootStyles.getPropertyValue(propertyName).trim() || fallback;
};

export const SocialButton: React.FC<ButtonLinkProps> = ({
  as: _as = 'button',
  color = getCSSCustomProperty('--color-surface', '#ffffff'),
  target = '_blank',
  linkUrl = '#',
  title = 'titulo aqui',
  icon,
  bgColor = getCSSCustomProperty('--color-background-dark', '#0049a9'),
  fontSize = '16px',
  ...props
}) => {
  const SocialButtonStyle = {
    backgroundColor: bgColor,
  };

  const styledIcon = React.cloneElement(icon, {
    style: {
      color: color,
      fontSize: fontSize,
    },
  });

  return (
    <a
      href={linkUrl}
      target={target}
      title={title}
      className={styles.btnSocial}
      style={SocialButtonStyle}
      {...props}
    >
      {styledIcon}
    </a>
  );
};
